import {Component, EventEmitter, Injector, Input, Output} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {NewCertificationService} from "./services/new-certification.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {CertificationRefreshService} from "./services/certification-refresh.service";

@Component({
    selector: 'app-new-certification-domain-list',
    templateUrl: './new-certification-domain-list.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class NewCertificationDomainListComponent extends BasePageComponentDirective<any> {

    domains: any[] = [];

    @Input() providers: any[] = [];
    @Input() attendanceTypes: any = {};
    @Input() certification: any = null;

    showCloseSearch = false;

    constructor(
        injector: Injector,
        private certificationService: NewCertificationService,
        private refreshSvc: CertificationRefreshService,
    ) {
        super(injector);
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.query();
        this.refreshSvc.currentMessage.subscribe(r => {
            if(r) {
                this.query();
            }
        })
    }

    query(): void {
        this.tableLoading = true;
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['domainName'];
        this.certificationService.getAllDomains(this.pageQuery, this.certification.id).then(r => {
            this.domains = r.content;
            this.page.emit(r);
        });
    }

    searchUser($event: any) {
        if ($event.key === 'Enter') {
            this.searchTerm = this.pageQuery.search;
            this.query();
            this.showCloseSearch = true;
        }
    }

    clearSearch() {
        this.searchTerm = '';
        this.pageQuery.search = '';
        this.query();
        this.showCloseSearch = false;
    }

    addNewDomain() {
        this.router.navigate([`/office/new-certification/detail/${this.certification.id}/domain/add-new`]).then();
    }

    detailDomain(certificationDomainId: number) {
        this.router.navigate([`/office/new-certification/detail/${this.certification.id}/domain/${certificationDomainId}/view`]).then();
    }

    editDomain(certificationDomainId: number) {
        this.router.navigate([`/office/new-certification/detail/${this.certification.id}/domain/${certificationDomainId}/edit`]).then();
    }

    deleteDomain(certificationDomainId: number) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const confirm = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                message: "Delete Certification Domain" ,
                subMessage: "Are you sure want to delete certification domain?",
                buttonOkLabel: 'Yes, Delete',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        });
        confirm.componentInstance.result.subscribe(r => {
            if(r) {
                this.certificationService.deleteCertificationDomain(this.certification?.id, certificationDomainId).then(r => {
                    this.showSnackbarDark('Certification Domain', 'Certification domain has been deleted successfully', '');
                    this.query();
                })

            }
        })
    }
}
